import { Stack } from "@chakra-ui/react";
import UnprocessedEmails from "@/features/unprocessed-emails/UnprocessedEmails";

const UnprocessedEmailsPage = () => {
  return (
    <Stack gap={5}>
      <UnprocessedEmails />
    </Stack>
  );
};
export default UnprocessedEmailsPage;
